// src/components/SearchAutocomplete.tsx
import React, { useState, useEffect } from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { TreeNode } from '@/shared/interfaces';
import { CircularProgress, ListItem, ListItemText } from '@mui/material';
import { useCatalogoPlanCuentaStore } from '@/store/erp/shared/catalogo-plan-cuenta.store';


interface CustomAutocompleteInventariableProps {
  onClick: (option: TreeNode) => void;
}

const CustomAutocompleteInventariable: React.FC<CustomAutocompleteInventariableProps> = ({ onClick }) => {

  const [inputValue, setInputValue] = useState('');
  const [filteredOptions, setFilteredOptions] = useState<TreeNode[]>([]);
  const { isLoadingCatalogoPlanCuenta: isLoadingPlanCuenta, catalogoPlanCuenta: cuentas } = useCatalogoPlanCuentaStore();

  useEffect(() => {
    if (!isLoadingPlanCuenta) {
      setFilteredOptions(cuentas);
    }
  }, [isLoadingPlanCuenta])


  useEffect(() => {

    try {
      if (inputValue && !isNaN(+inputValue.charAt(0))) {
        const newOptions = cuentas.filter((option) =>
          option.name!.startsWith(inputValue)
        );
        setFilteredOptions(newOptions);
      } else {
        const newOptions = cuentas.filter((option) =>
          option.name!.toLowerCase().includes(inputValue.toLowerCase())
        );
        setFilteredOptions(newOptions);
      }
    } catch (error) {
      console.log(error);
    }
  }, [inputValue]);


  if (isLoadingPlanCuenta) return <CircularProgress color="inherit" />

  return (
    <Autocomplete
      options={filteredOptions}
      //loading={isLoadingPlanCuenta}
      getOptionLabel={(option) => option.name!}
      loadingText={'Cargando...'}
      disableClearable={true}
      noOptionsText='No se encontraron opciones'
      renderInput={(params) => (
        <TextField {...params} label="Buscar plan de cuenta" variant="outlined" />
      )}
      inputValue={inputValue}
      onInputChange={(_event, newInputValue) => {
        setInputValue(newInputValue);
      }}
      filterOptions={(x) => x} // Desactiva la búsqueda por defecto
      renderOption={(_props, option) => (
        <ListItem
          sx={{
            padding: '2px 10px',
            cursor: 'pointer'
          }}
          component='div'
          disableGutters
          onClick={() => {
            onClick(option);
          }}
        >
          <ListItemText primary={option.name} />
        </ListItem >
      )}
    />
  );
};

export default CustomAutocompleteInventariable;
